"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.classLoader = exports.ClassLoader = exports.DuplicateRegistrationError = void 0;
var metadata_1 = require("./metadata");
var utils_1 = require("../utils");
var DuplicateRegistrationError = /** @class */ (function (_super) {
    __extends(DuplicateRegistrationError, _super);
    function DuplicateRegistrationError(type) {
        return _super.call(this, "Type " + type.name + " is already registration.") || this;
    }
    return DuplicateRegistrationError;
}(Error));
exports.DuplicateRegistrationError = DuplicateRegistrationError;
var ClassLoader = /** @class */ (function () {
    function ClassLoader(classInfoMap, implementCacheMap) {
        if (classInfoMap === void 0) { classInfoMap = new Map(); }
        if (implementCacheMap === void 0) { implementCacheMap = new Map(); }
        this.classInfoMap = classInfoMap;
        this.implementCacheMap = implementCacheMap;
    }
    /** has class */
    ClassLoader.prototype.hasClass = function (type) {
        return this.classInfoMap.has(type);
    };
    /** register class */
    ClassLoader.prototype.registerClass = function (type, info) {
        var _this = this;
        var _a;
        if (this.classInfoMap.has(type)) {
            throw new DuplicateRegistrationError(type);
        }
        var metadata = metadata_1.getMetadata(type);
        metadata.injectable = true;
        info = info || metadata.classInfo;
        if (!info.name) {
            info.name = type.name;
        }
        if (!((_a = info.extends) === null || _a === void 0 ? void 0 : _a.length)) {
            var superClasses = utils_1.getSuperClassInfo(type);
            info.extends = superClasses.map(function (c) { return c.class; });
        }
        this.classInfoMap.set(type, info);
        if (!info.implements) {
            info.implements = [];
        }
        // add cache
        __spreadArrays(info.extends, info.implements).forEach(function (ext) {
            var impls = _this.getImplCacheByType(ext);
            if (impls.every(function (impl) { return impl.type !== type; })) {
                impls.push({
                    type: type,
                    info: info,
                });
            }
        });
        return this;
    };
    /** unregister class */
    ClassLoader.prototype.unregisterClass = function (type) {
        var _this = this;
        var info = this.classInfoMap.get(type);
        if (info) {
            // remove from cache
            __spreadArrays(info.extends, info.implements).forEach(function (ext) {
                var cache = _this.getImplCacheByType(ext);
                var index = cache.findIndex(function (c) { return c.type === type; });
                /* istanbul ignore else */
                if (index >= 0) {
                    cache.splice(index, 1);
                }
            });
            this.classInfoMap.delete(type);
        }
    };
    /** get class info */
    ClassLoader.prototype.getClassInfo = function (type) {
        return this.classInfoMap.get(type);
    };
    /** filter classes by info */
    ClassLoader.prototype.filterClasses = function (pattern) {
        var classes = [];
        this.classInfoMap.forEach(function (info, type) {
            var typeWithInfo = { type: type, info: info };
            if (pattern(typeWithInfo)) {
                classes.push(typeWithInfo);
            }
        });
        return classes;
    };
    /** classes of extends/implements type */
    ClassLoader.prototype.getImplementClasses = function (type) {
        return this.getImplCacheByType(type);
    };
    ClassLoader.prototype.clearAll = function () {
        this.classInfoMap.clear();
        this.implementCacheMap.clear();
        return this;
    };
    /** return new instance from this */
    ClassLoader.prototype.clone = function () {
        return new ClassLoader(new Map(this.classInfoMap), this.cloneImplCacheMap(this.implementCacheMap));
    };
    /**
     * init maps from instance
     * @param classLoader source loader
     */
    ClassLoader.prototype.initWith = function (classLoader) {
        this.classInfoMap = new Map(classLoader.classInfoMap);
        this.implementCacheMap = this.cloneImplCacheMap(classLoader.implementCacheMap);
    };
    ClassLoader.prototype.cloneImplCacheMap = function (map) {
        return new Map(Array.from(map.entries()).map(function (_a) {
            var k = _a[0], v = _a[1];
            return [k, __spreadArrays(v)];
        }));
    };
    ClassLoader.prototype.getImplCacheByType = function (type) {
        var key = utils_1.getGlobalType(type);
        if (!this.implementCacheMap.has(key)) {
            this.implementCacheMap.set(key, []);
            return this.getImplCacheByType(type);
        }
        return this.implementCacheMap.get(key);
    };
    return ClassLoader;
}());
exports.ClassLoader = ClassLoader;
exports.classLoader = new ClassLoader();
//# sourceMappingURL=ClassLoader.js.map